export enum HeaderTabs {
    Vehicles = 'vehicles',
    FinanceProducts = 'financeProducts',
    ModuleDetails = 'moduleDetails',
}

export enum EditMode {
    ModuleDetails = 'moduleDetails',
}

export type StandardApplicationCounterFieldKey =
    | 'leadCounter'
    | 'applicationCounter'
    | 'reservationCounter'
    | 'appointmentCounter'
    | 'insuranceCounter';
